/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { IconButton } from "@/subframe/components/IconButton";
import VoiceRecorder from './VoiceRecorder';

interface VoiceMessageHandlerProps {
  currentRecipient: any;
}

const VoiceMessageHandler: React.FC<VoiceMessageHandlerProps> = ({ currentRecipient }) => {
  const [isRecorderOpen, setIsRecorderOpen] = useState(false);

  const handleOpenRecorder = () => {
    setIsRecorderOpen(true);
  };

  const handleCloseRecorder = () => {
    setIsRecorderOpen(false);
  };

  return (
    <>
      <IconButton 
        variant="neutral-secondary" 
        icon="FeatherMic"
        onClick={handleOpenRecorder}
      />
      
      {isRecorderOpen && (
        <VoiceRecorder
          currentRecipient={currentRecipient}
          onClose={handleCloseRecorder}
        />
      )}
    </>
  );
};

export default VoiceMessageHandler;